import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncRemoveSimpleWorkflowsModalSection = Loadable({
  loader: () => import( /* webpackChunkName: "simple-workflows-delete-modal" */'./RemoveSimpleWorkflowsModalSection'),
  LoadingComponent: () => /*#__PURE__*/_jsx(LoadingSpinner, {})
});
export default AsyncRemoveSimpleWorkflowsModalSection;